import { gsap } from "gsap";

export default class Accordions {
    constructor() { this.init(); }

    init() {
        const items = gsap.utils.toArray(".accordion-item");
        if (!items.length) return;

        this.items = items.map((root, i) => this.setupItem(root, i));

        // ouvrir le premier ou data-default-open="true"
        this.items.forEach((it, i) => {
            const hasAttr = it.root.hasAttribute("data-default-open");
            const open = hasAttr ? it.root.dataset.defaultOpen === "true" : i === 0;
            this.setInitialState(it, open);
        });
    }

    setupItem(root, index) {
        const header  = root.querySelector(".accordion-item_header");
        const btn     = header?.querySelector(".question_btn") || header;
        const panel   = root.querySelector(".accordion-item_content");
        const panelId = btn.getAttribute("aria-controls") || `acc-panel-${index+1}`;

        if (panel && !panel.id) panel.id = panelId;
        btn.setAttribute("aria-controls", panel.id);

        panel.style.overflow = "hidden";
        panel.hidden = true;

        // click sur header = click bouton (mais pas si on a cliqué un vrai bouton/lien dedans)
        header.addEventListener("click", (e) => {
            if (!e.target.closest("button,a,summary")) btn.click();
        });

        btn.addEventListener("click", (e) => {
            e.preventDefault();
            const willOpen = btn.getAttribute("aria-expanded") !== "true";
            this.toggle(root, willOpen);
        });

        return { root, header, btn, panel };
    }

    setInitialState(it, open) {
        it.btn.setAttribute("aria-expanded", open ? "true" : "false");
        it.root.classList.toggle("active", open);
        if (open) {
            it.panel.hidden = false;
            it.panel.style.height = "auto";
        } else {
            it.panel.hidden = true;
            it.panel.style.height = "0px";
        }
    }

    toggle(root, open) {
        // accordéon exclusif (ferme les autres)
        this.items.forEach((it) => {
            if (it.root !== root && it.btn.getAttribute("aria-expanded") === "true") {
                this.animateClose(it);
            }
        });
        const current = this.items.find((it) => it.root === root);
        if (!current) return;
        open ? this.animateOpen(current) : this.animateClose(current);
    }

    animateOpen(it) {
        const el = it.panel;
        gsap.killTweensOf(el);

        el.hidden = false;
        const start = el.offsetHeight;
        el.style.height = start + "px";
        const target = el.scrollHeight;

        it.root.classList.add("active");
        it.btn.setAttribute("aria-expanded", "true");

        gsap.fromTo(el,
            { height: start },
            {
                height: target,
                duration: 0.45,
                ease: "power2.out",
                clearProps: "height",
            }
        );
    }

    animateClose(it) {
        const el = it.panel;
        gsap.killTweensOf(el);

        const start = el.offsetHeight || el.scrollHeight;
        el.style.height = start + "px";

        it.root.classList.remove("active");
        it.btn.setAttribute("aria-expanded", "false");

        gsap.to(el, {
            height: 0,
            duration: 0.35,
            ease: "power1.inOut",
            onComplete: () => {
                el.hidden = true;
                el.style.height = "0px";
            },
        });
    }
}
